module.exports = __webpack_public_path__ + "img/help_dataset_state.6b816de6.png";